import Component from '../abstracts/Component';

export default class ListingEditorialComponent extends Component {
  get SELECTORS() {
    return {
      listingPush: '[data-listing-push]',
      listingVerticalPush: '[data-listing-vertical-push]',
      prevArrow: "[data-prev-arrow-lvp]",
      nextArrow: "[data-next-arrow-lvp]",
      productsContainer: "[data-products-container]",
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.productsContainer = this.$component.querySelector(this.SELECTORS.productsContainer);
  }

  render() {
    super.render();
    this.bindEvents();
    this.importLibrary();
  }

  importLibrary(elem) {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        if (document.querySelector(this.SELECTORS.listingVerticalPush)) {
          this.initCarousels(elem);
        }
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  initCarousels(){
    const verticalPushDOM = document.querySelectorAll(".w-listing-vertical-push");
    verticalPushDOM.forEach(element => {
      if (!element.classList.contains("slick-initialized")) {
        const arrowL = element.querySelector(this.SELECTORS.prevArrow);
        const arrowR = element.querySelector(this.SELECTORS.nextArrow);
        if(arrowL && arrowR) {
          const carouselWrapper = element.querySelector(".l-v-p__wrapper");
          $(carouselWrapper).slick({
            arrows: true,
            prevArrow: arrowL,
            nextArrow: arrowR,
          });
        }
      }
    });
  }

  bindEvents() {
    let ctx = this;
    //hides editorial content after filtering
    this.$on(this.$customEvents.FILTERS_EVENTS.pageLoaded, function() {
      document.querySelectorAll(ctx.SELECTORS.listingPush).forEach( function(item) {
        item.classList.add('hidden');
      });
      document.querySelectorAll(ctx.SELECTORS.listingVerticalPush).forEach( function(item) {
        item.classList.add('hidden');
      })
    });

    this.$on(this.$customEvents.LISTING_GRID_MODE.on, ({event, payload}) => {
      this.productsContainer?.classList.add("--grid-mode");
    });

    this.$on(this.$customEvents.LISTING_GRID_MODE.off, ({event, payload}) => {
      this.productsContainer?.classList.remove("--grid-mode");
    });
  }
}
